import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { HttpRequest } from "@/core/common/http/http-request";
import { PayrollLineDto } from "@/core/features/payrolls/payroll-line.dto";
import { CreatePayrollLineDto } from "@/core/features/payrolls/create-payroll-line.dto";
import { UpdatePayrollLineDto } from "@/core/features/payrolls/update-payroll-line.dto";
import { plainToInstance } from "class-transformer";

export class PayrollLinesResource {
  constructor(private readonly apiHttpClient: ApiHttpClient) {}

  list(payrollId: string): Promise<PayrollLineDto[]> {
    return this.apiHttpClient
      .request<null, PayrollLineDto[]>(
        HttpRequest.create({
          url: `/api/payrolls/${payrollId}/lines`,
          method: "GET",
          auth: true,
        })
      )
      .then((result: PayrollLineDto[]) => plainToInstance(PayrollLineDto, result));
  }

  create(payrollId: string, body: CreatePayrollLineDto): Promise<PayrollLineDto> {
    return this.apiHttpClient
      .request<CreatePayrollLineDto, PayrollLineDto>(
        HttpRequest.create({
          url: `/api/payrolls/${payrollId}/lines`,
          method: "POST",
          auth: true,
          body: plainToInstance(CreatePayrollLineDto, body, { excludeExtraneousValues: true }),
        })
      )
      .then((result: PayrollLineDto) => plainToInstance(PayrollLineDto, result));
  }

  update(payrollId: string, lineId: string, body: UpdatePayrollLineDto): Promise<PayrollLineDto> {
    return this.apiHttpClient
      .request<UpdatePayrollLineDto, PayrollLineDto>(
        HttpRequest.create({
          url: `/api/payrolls/${payrollId}/lines/${lineId}`,
          method: "PATCH",
          auth: true,
          body: plainToInstance(UpdatePayrollLineDto, body, { excludeExtraneousValues: true }),
        })
      )
      .then((result: PayrollLineDto) => plainToInstance(PayrollLineDto, result));
  }

  remove(payrollId: string, lineId: string): Promise<void> {
    return this.apiHttpClient.request<void, void>(
      HttpRequest.create({
        url: `/api/payrolls/${payrollId}/lines/${lineId}`,
        method: "DELETE",
        auth: true,
        type: "text",
      })
    );
  }
}
